<template>
  <div class="consultCard">
    <div class="title">{{ props.info.titleToDoctorAssistant }}</div>
    <div class="content">
      <div class="cell" v-for="(item, index) in getCellConfig(props?.info).list" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="value" :style="item?.contentStyle">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'
import moment from 'moment'
const props = defineProps({
  info: {
    type: Object,
    default: () => ({})
  }
})
const getCellConfig = data => {
  const {
    eventType,
    patientName,
    patientGender,
    patientAge,
    expectedStartTime,
    expectedEndTime,
    confirmTime
  } = data
  // 期望咨询时间
  const expectTimeObj = {
    momentTime: moment(expectedStartTime).format('MM.DD'),
    momentTimeStart: moment(expectedStartTime).format('HH:mm'),
    momentTimeEnd: moment(expectedEndTime).format('HH:mm')
  }
  // 确认咨询时间
  const confirmIqTimeObj = {
    momentTime: moment(confirmTime).format('MM.DD'),
    momentTimeStart: moment(confirmTime).format('HH:mm')
  }
  //就诊人
  const patient = {
    label: '就诊人：',
    content: `${patientName} ${patientGender} ${
      patientAge && parseInt(patientAge) > 0 ? `·${patientAge}岁` : ''
    }`
  }
  // 期望咨询时间
  const expectTime = {
    label: '期望咨询时间：',
    content: `${expectTimeObj.momentTime} ${expectTimeObj.momentTimeStart} - ${expectTimeObj.momentTimeEnd}`
  }
  // 确认咨询时间
  const confirmIqTime = {
    label: '确认咨询时间：',
    content: `${confirmIqTimeObj.momentTime} ${confirmIqTimeObj.momentTimeStart}`,
    contentStyle: {
      color: '#F45959'
    }
  }
  // 调整咨询时间
  const adjustIqTime = {
    label: '调整咨询时间：',
    content: `${confirmIqTimeObj.momentTime} ${confirmIqTimeObj.momentTimeStart}`,
    contentStyle: {
      color: '#F45959'
    }
  }
  switch (eventType) {
    case '1':
    case '13':
      return {
        list: [patient, expectTime]
        // 扩展其他字端
      }
    case '2':
    case '4':
    case '6':
    case '14':
    case '16':
    case '18':
      return { list: [patient, confirmIqTime] }
    case '3':
    case '5':
    case '7':
    case '15':
    case '17':
    case '19':
      return { list: [patient, adjustIqTime] }
    default:
      return { list: [] }
  }
}
</script>
<style scoped lang="scss">
.consultCard {
  padding: 12px 16px;
  background-image: url('~@/assets/img/chat/phoneBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #1a1a1a;
    text-align: left;
  }
  .content {
    padding: 8px 0 4px 0;
    .cell {
      display: flex;
      margin-bottom: 4px;
      .label {
        font-weight: 400;
        font-size: 14px;
        color: #818fa0;
        flex-shrink: 0;
      }
      .value {
        font-weight: 500;
        font-size: 13px;
        color: #3b3b3b;
      }
    }
    .cell:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
